export default __webpack_public_path__ + "static/media/error_icon.37646b27.svg";